module.exports = __webpack_public_path__ + "img/sharsheret_no.3d6a8cef.png";